module.exports = __webpack_public_path__ + "static/reduce-admin-f3842e8c4ad62237fa9562f20866ccf1.jpg";